import { createSelector } from 'reselect';
import { StateType } from '../../../types';

export const getDefaultLandingReferral = (state: StateType) => state.defaultLandingReferral;

export const getProfilePublicData = createSelector(
  getDefaultLandingReferral,
  (defaultLandingReferral) => defaultLandingReferral.profile.data,
);
